export default {
  styleOverrides: {
    root: {
      backgroundColor: '#2e2e2e',
      backgroundImage: 'unset',
    },
  },
};
